<!-- Month / Day / Year rather than a calendar: a birth year is reachable by
     typing in the year list instead of paging a calendar back decades.
     Each part is named, so there is no MM/DD vs DD/MM ambiguity. -->
<div class="dob-picker" [class.dob-picker--small]="small" (focusout)="onFocusOut($event)">
  <div class="dob-picker__part dob-picker__part--month">
    <select class="form-select"
            [class.form-select-sm]="small"
            [class.dob-picker__select--invalid]="invalid"
            [id]="idPrefix + 'Month'"
            [attr.aria-label]="'Month of birth'"
            [disabled]="disabled"
            [(ngModel)]="month"
            [ngModelOptions]="{standalone: true}"
            (ngModelChange)="onPartChange()">
      <option value="">Month</option>
      <option *ngFor="let m of months" [value]="m.value">{{ m.label }}</option>
    </select>
  </div>

  <div class="dob-picker__part dob-picker__part--day">
    <select class="form-select"
            [class.form-select-sm]="small"
            [class.dob-picker__select--invalid]="invalid"
            [id]="idPrefix + 'Day'"
            [attr.aria-label]="'Day of birth'"
            [disabled]="disabled"
            [(ngModel)]="day"
            [ngModelOptions]="{standalone: true}"
            (ngModelChange)="onPartChange()">
      <option value="">Day</option>
      <option *ngFor="let d of days" [value]="d">{{ d }}</option>
    </select>
  </div>

  <div class="dob-picker__part dob-picker__part--year">
    <select class="form-select"
            [class.form-select-sm]="small"
            [class.dob-picker__select--invalid]="invalid"
            [id]="idPrefix + 'Year'"
            [attr.aria-label]="'Year of birth'"
            [disabled]="disabled"
            [(ngModel)]="year"
            [ngModelOptions]="{standalone: true}"
            (ngModelChange)="onPartChange()">
      <option value="">Year</option>
      <option *ngFor="let y of years" [value]="y">{{ y }}</option>
    </select>
  </div>
</div>
